import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.foreground};
`

export const Header = styled.div`
  background-color: ${({ theme }) => theme.colors.headerBackground};
  display: flex;
  min-height: 60px;
  padding-top: env(safe-area-inset-top);
`

export const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background-color: ${({ theme }) => theme.colors.background};
`

export const Brand = styled.img`
  height: 44px;
  width: 44px;
  margin: 2px 10px 2px 0;
  object-fit: contain;
`

export const RouteName = styled.span`
  font-size: 20px;
  padding: 10px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.headerText};
`
